/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright Copyright (c) 2021, Zumper
 */

import { filterActions } from '@zumper/redux-ignore'

import * as constants from './constants'
import { profileShareReducer } from './reducers/index'

export const profileShare = filterActions(profileShareReducer, Object.values(constants))
